module.exports = __webpack_public_path__ + "static/media/target1_1.c5c8629b.png";